<template>
  <div class="chat-area-input" v-if="asta_squadre[user_uid]">
    <v-row align="center" no-gutters>
      <v-col>
        <v-text-field
          id="messageInput"
          class="chat-input pa-2 ma-0"
          v-model.trim="messageInput"
          @keyup.native.enter="send()"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          fab
          depressed
          small
          color="primary"
          class="mr-2 white--text"
          @click="send()"
          :disabled="messageInput.length == 0"
        >
          <v-icon small>send</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vuex from "vuex";
import db from "../js/db";
import mixins from "../js/mixins";

export default {
  name: "asta-chat-input",
  mixins: [mixins],
  data() {
    return {
      inputDisabled: true,
      emojionArea: null,
      messageInput: "",
    };
  },
  /* mounted() {
      db.on('fetchedSquadre', this.setupEmojioneArea);
      this.setupEmojioneArea();
  },*/
  methods: {
    /*setupEmojioneArea() {
        if (this.squadra(this.user_uid) && this.emojionArea == null) {
          let emotionarea = $("#messageInput").emojioneArea({
            pickerPosition: "top",
            filtersPosition: "bottom",
            inline: true,
            sprite: false
          });

          this.emojionArea = emotionarea[0].emojioneArea;
          this.emojionArea.on('keydown', function (editor, event) {
            if (event.which == 13) {
              this.send();
            }
          }.bind(this));

          this.emojionArea.on('keyup change emojibtn.click', function (editor, event) {
            this.inputDisabled = this.emojionArea.getText().length === 0;
          }.bind(this));

        }
      },*/
    send() {
      if (this.messageInput.length) {
        db.addMessage(this.messageInput, (error) => {
          if (!error) {
            this.messageInput = "";
          }
        });
      }
      /*let messageText = this.emojionArea.getText();
        if (messageText.length){
          db.addMessage(messageText, function (error) {
            if (!error) {
              this.emojionArea.hidePicker();
              this.emojionArea.setText('');
            }
          }.bind(this))
        };*/
    },
  },
  computed: {
    ...Vuex.mapGetters(["asta_info"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.chat-area-input {
  // box-shadow: 0 5px 22px 0 rgb(0 0 0 / 20%);
  background: var(--v-navy-darken1);
  margin: 0px auto;
  border-radius: 100px;
  padding-left: 15px;
  max-width: 600px;
}

img.emojione {
  width: 24px;
  height: 24px;
}

.emojionearea {
  margin-top: 8px;
  text-align: left;
}

.chat-input {
  font-size: $font-size;
    color: white
}
</style>
